import { __decorate, __param } from 'tslib';
import { isPlatformBrowser, DOCUMENT, CommonModule } from '@angular/common';
import { Injectable, Inject, PLATFORM_ID, RendererFactory2, ɵɵdefineInjectable, ɵɵinject, NgModule } from '@angular/core';

import * as ɵngcc0 from '@angular/core';
let AngularCallTouchCounterConfig = class AngularCallTouchCounterConfig {
};
AngularCallTouchCounterConfig.ɵfac = function AngularCallTouchCounterConfig_Factory(t) { return new (t || AngularCallTouchCounterConfig)(); };
AngularCallTouchCounterConfig.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: AngularCallTouchCounterConfig, factory: function (t) { return AngularCallTouchCounterConfig.ɵfac(t); } });

let AngularCallTouchCounterService = class AngularCallTouchCounterService {
    constructor(documentRef, platformId, rendererFactory, config) {
        this.documentRef = documentRef;
        this.platformId = platformId;
        this.rendererFactory = rendererFactory;
        this.config = config;
        this.doc = this.documentRef;
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }
    /**
     * Initialize CallTouch Counter tracking script
     * - Adds the script to page's head
     */
    initialize(counterId = this.config.counterId) {
        if (this.isLoaded()) {
            console.warn('Tried to initialize a CallTouch Counter instance while another is already active. Please call `remove()` before initializing a new instance.');
            return;
        }
        this.config.enabled = true;
        this.addCallTouchCounterScript(counterId);
    }
    /** Remove the CallTouch Counter tracking script */
    remove() {
        this.removeCallTouchCounterScript();
        this.config.enabled = false;
    }
    /**
     * Adds CallTouch Counter tracking script to the application
     * @param counterId CallTouch Counter ID to use
     */
    addCallTouchCounterScript(counterId) {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        const counterCode = `(function(w,d,n,c){w.CalltouchDataObject=n;w[n]=function(){w[n]["callbacks"].push(arguments)};if(!w[n]["callbacks"]){w[n]["callbacks"]=[]}w[n]["loaded"]=false;if(typeof c!=="object"){c=[c]}w[n]["counters"]=c;for(var i=0;i<c.length;i+=1){p(c[i])}function p(cId){var a=d.getElementsByTagName("script")[0],s=d.createElement("script"),i=function(){a.parentNode.insertBefore(s,a)},m=typeof Array.prototype.find === 'function',n=m?"init-min.js":"init.js";s.type="text/javascript";s.async=true;s.src="https://mod.calltouch.ru/"+n+"?id="+cId;if(w.opera=="[object Opera]"){d.addEventListener("DOMContentLoaded",i,false)}else{i()}}})(window,document,"ct","${counterId}");`;
        const scriptElement = this.renderer.createElement('script');
        this.renderer.setAttribute(scriptElement, 'id', 'calltouch-counter-script');
        this.renderer.setAttribute(scriptElement, 'type', 'text/javascript');
        this.renderer.setProperty(scriptElement, 'innerHTML', counterCode);
        this.renderer.appendChild(this.doc.head, scriptElement);
    }
    /** Remove CallTouch Counter tracking script from the application */
    removeCallTouchCounterScript() {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }
        const callTouchCounterElement = this.doc.getElementById('calltouch-counter-script');
        if (callTouchCounterElement) {
            callTouchCounterElement.remove();
        }
    }
    /** Checks if the script element is present */
    isLoaded() {
        if (isPlatformBrowser(this.platformId)) {
            const callTouchCounterElement = this.doc.getElementById('calltouch-counter-script');
            return !!callTouchCounterElement;
        }
        return false;
    }
};
AngularCallTouchCounterService.ɵfac = function AngularCallTouchCounterService_Factory(t) { return new (t || AngularCallTouchCounterService)(ɵngcc0.ɵɵinject(DOCUMENT), ɵngcc0.ɵɵinject(PLATFORM_ID), ɵngcc0.ɵɵinject(ɵngcc0.RendererFactory2), ɵngcc0.ɵɵinject(AngularCallTouchCounterConfig)); };
AngularCallTouchCounterService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [DOCUMENT,] }] },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] },
    { type: RendererFactory2 },
    { type: AngularCallTouchCounterConfig }
];
AngularCallTouchCounterService.ɵprov = ɵɵdefineInjectable({ factory: function AngularCallTouchCounterService_Factory() { return new AngularCallTouchCounterService(ɵɵinject(DOCUMENT), ɵɵinject(PLATFORM_ID), ɵɵinject(RendererFactory2), ɵɵinject(AngularCallTouchCounterConfig)); }, token: AngularCallTouchCounterService, providedIn: "root" });
AngularCallTouchCounterService = __decorate([ __param(0, Inject(DOCUMENT)),
    __param(1, Inject(PLATFORM_ID))
], AngularCallTouchCounterService);

var AngularCallTouchCounterModule_1;
let AngularCallTouchCounterModule = AngularCallTouchCounterModule_1 = class AngularCallTouchCounterModule {
    constructor(angularCallTouchCounter, platformId) {
        this.angularCallTouchCounter = angularCallTouchCounter;
        if (!AngularCallTouchCounterModule_1.config) {
            throw Error('angular-calltouch-counter not configured correctly. Pass the `counterId` property to the `forRoot()` function');
        }
        if (AngularCallTouchCounterModule_1.config.enabled &&
            isPlatformBrowser(platformId)) {
            this.angularCallTouchCounter.initialize();
        }
    }
    /**
     * Initialize the Angular CallTouch Counter Module
     *
     * Add your CallTouch Counter ID as parameter
     */
    static forRoot(config) {
        this.config = config;
        const counterId = config.counterId;
        this.verifyCounterId(counterId);
        return {
            ngModule: AngularCallTouchCounterModule_1,
            providers: [
                AngularCallTouchCounterService,
                { provide: AngularCallTouchCounterConfig, useValue: config },
            ],
        };
    }
    /**
     * Verifies the Counter ID that was passed into the configuration.
     * - Checks if Counter was initialized
     * @param counterId Counter ID to verify
     */
    static verifyCounterId(counterId) {
        if (counterId === null || counterId === undefined || counterId.length === 0) {
            throw Error('Invalid CallTouch Counter ID. Did you pass the ID into the forRoot() function?');
        }
    }
};
AngularCallTouchCounterModule.ɵfac = function AngularCallTouchCounterModule_Factory(t) { return new (t || AngularCallTouchCounterModule)(ɵngcc0.ɵɵinject(AngularCallTouchCounterService), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
AngularCallTouchCounterModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: AngularCallTouchCounterModule });
AngularCallTouchCounterModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
AngularCallTouchCounterModule.config = null;
AngularCallTouchCounterModule.ctorParameters = () => [
    { type: AngularCallTouchCounterService },
    { type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
AngularCallTouchCounterModule = AngularCallTouchCounterModule_1 = __decorate([ __param(1, Inject(PLATFORM_ID))
], AngularCallTouchCounterModule);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularCallTouchCounterConfig, [{
        type: Injectable
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularCallTouchCounterService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: ɵngcc0.RendererFactory2 }, { type: AngularCallTouchCounterConfig }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AngularCallTouchCounterModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [CommonModule]
            }]
    }], function () { return [{ type: AngularCallTouchCounterService }, { type: Object, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AngularCallTouchCounterModule, { imports: function () { return [CommonModule]; } }); })();

/**
 * Public API Surface of angular-calltouch-counter
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AngularCallTouchCounterModule, AngularCallTouchCounterService, AngularCallTouchCounterConfig as ɵa };

